export const createSendbirdUser = {
  apiUrl: "/chatbot/create-sendbird-user",
};
